import { CircularProgress, Stack } from "@mui/material";

import PaginationControlsV2 from "../../../../global/PaginationControlsV2";
import HNSColors from "../../../../ui library/HNSColors";
import { useAISummaryStore } from "../../store/aiSummaryStore";
import { STRINGS } from "../../utils/strings";
import CallSummaryList from "../List/CallSummaryList";

export default function LeftBottomPanel() {
  const { data, loading, resultCount, currentPage, resLimit, setCurrentPage, chipData } =
    useAISummaryStore();
  const handlePageChange = (_, newPage) => setCurrentPage(newPage);

  if (loading) {
    return (
      <div className="flex h-full w-full flex-row items-center justify-center py-4">
        <CircularProgress style={{ color: HNSColors.secondary[500] }} />
      </div>
    );
  }

  const hasFilters = Array.isArray(chipData) && chipData.length > 0;
  const showCopiedLegend = resultCount > 0 && !hasFilters;

  const CopiedLegend = () => {
    return (
      <div className="flex items-center gap-4 px-2">
        <div className="flex items-center gap-1.5">
          <div
            className="h-5 w-5 rounded-full"
            style={{ backgroundColor: HNSColors.tertiary[500] }}
          />
          <span className="text-sm text-gray-600">Copied</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div
            className="h-5 w-5 rounded-full"
            style={{ backgroundColor: HNSColors.secondary[700] }}
          />
          <span className="text-sm text-gray-600">Not Copied</span>
        </div>
      </div>
    );
  };

  return (
    <div className="flex h-full flex-col gap-4">
      {showCopiedLegend && <CopiedLegend />}
      <div className="relative flex flex-1 flex-col gap-2 overflow-y-auto">
        <CallSummaryList data={data} />
      </div>
      {resultCount > STRINGS.DEFAULT_PAGINATION_LIMIT && (
        <div className={`flex w-full justify-center`}>
          <Stack alignItems="center">
            <PaginationControlsV2
              alignment="center"
              resultCount={resultCount}
              handleChange={handlePageChange}
              currentPage={currentPage}
              resultLimit={resLimit}
            />
          </Stack>
        </div>
      )}
    </div>
  );
}
